<!-- <div class="overlay" [class.visible]="isVisible" (click)="closeSidebar(false)"></div> -->
<div *ngIf="garageKey" class="overlay" [class.visible]="isVisible" (click)="closeSidebar(false)"></div>
<div *ngIf="!garageKey" class="overlay" [class.visible]="isVisible" ></div>
<div class="sidebar" [class.visible]="isVisible" >
   <div class="order-container">
      <div>
      <header>
         <div class="back-button" *ngIf="!garageKey">
            <div class="title">Select Garage</div>
         </div>
         <div class="back-button" *ngIf="garageKey">
            <i  (click)="closeSidebar(false)" class="material-icons" style="color: black;font-weight: bold; cursor: pointer;width: 10%;">arrow_back</i>
            <div class="title" style="width: 90%;text-align: center;margin-right: 15px;">Select Garage</div>
            <i style="cursor: pointer;font-size: 18px;"  (click)="closeSidebar(false)">cancel</i>
         </div>
         
          
      </header>
            <!-- <div style="padding: 0px 8px;">
               <i class="searchIcon">search</i>
               <input
                  type="text" class="SearchInput1" placeholder="Search Garages..." [(ngModel)]='searchText' name="searchText" autocomplete="off" (keyup)="searchFilterType()" >
               <button (click)="clearSearch()" class="button">
                  <i class="material-icons" style="font-size: 16px;">clear</i>
               </button>
            </div> -->
          <div class="select-garage-SearchBarContainer" (click)="garageSearch()" style="padding: 0;" >
                <div class="SearchBarButton">
                  <div class="SearchBarIcon">
                    <i class="material-icons">search</i>
                  </div>
                  <div class="SearchBarPlaceholder">
                    <div class="SearchBarAnimation" *ngIf="!isInputVisible">
                      <div id="animationText-1" class="SearchBarAnimationText">Search By "Garage Name"</div>
                      <div id="animationText-2" class="SearchBarAnimationText">Search By "Customer ID"</div>
                      <div id="animationText-3" class="SearchBarAnimationText">Search By "Status"</div>
                      <div id="animationText-4" class="SearchBarAnimationText">Search By "Zone"</div>
                    </div>
              
                    <div *ngIf="isInputVisible" class="SearchInputContainer" >
                        <input
                          #garageSearchInput
                          type="text"
                          placeholder="Type your search"
                          class="garageSearchInput"
                          [(ngModel)]="searchText"
                          (click)="garageSearch()"
                          (keyup)="searchFilterType()"
                        >
                        <button (click)="clearSearch()" class="button">
                          <i class="material-icons" style="font-size: 16px;">clear</i>
                        </button>
                      
                    </div>
                  </div>
                </div>
              </div>
         </div>
         <div id="switch-garage-form">
         <div *ngFor="let list of filteredGarage" style="padding: 0px 10px;    margin-bottom: 10px;">
            <!-- {{list | json}} -->
             <div 
            class="garage-name" 
            [ngClass]="{'selected-garage': garageKey === list.garageKey}"
            
            (click)="selectGarage(list.garageKey, list.name,list.contactName, list.contactEmail, list.contactPhone,list.spareGarageId,list.garageType, list.zone)" >
             <label [ngClass]="{'custom-radio-label': garageKey === list.garageKey}" style="margin-top: 9px;">
               <input
                  type="radio" 
                  name="garage"
                  [value]="list.garageKey"
                  [(ngModel)]="garageKey"
               />
               <span class="custom-radio"></span>
            </label>
            <div class="garage-info">
               <div class="header-row">
                  <h4 [innerHTML]="highlightMatch(list.name)"></h4>
                  <span class="status-badge" *ngIf="list.status== 1">Active</span>
                  <span class="status-inactive" *ngIf="list.status== 0">Inactive</span>
               </div>
               <div class="zone-address">
               <p class="zoho-id" *ngIf="list.zohoCustomerId">CUSTOMER ID:  <strong [innerHTML]="highlightMatch(list.zohoCustomerId)"></strong></p>
               
               <span class="zone" *ngIf="list.zone != null" 
                  [innerHTML]="highlightMatch(
                  (
                     list.zone?.lastIndexOf('-') !== -1 
                        ? list.zone?.substring(list.zone.lastIndexOf('-') + 1) 
                        : list.zone
                  )?.trim() || '', 
                  'zone')">
            </span>
               </div>
               <p class="address">{{ list.garageAddress  }}</p>
            </div>
 
              
           </div>
         </div>
     </div>
   </div>

</div>
